import { Enums } from '@bode-canada/core';
import { PROVINCES } from '@/constants';

interface CommissionCalculatorOptionInterface {
  id: string;
  name: string;
  value: Enums.ProvinceEnum;
  text: string;
}

type StartPriceType = { [key in Enums.ProvinceEnum]?: number };

interface MinMaxPriceInterface {
  MIN: number;
  MAX: number;
}

export const StartPrice: StartPriceType = {
  [PROVINCES.AB]: 800000,
  [PROVINCES.BC]: 1000000,
  [PROVINCES.ON]: 1000000,
};

export const MinMaxPrice: MinMaxPriceInterface = {
  MIN: 100000,
  MAX: 5000000,
};

export const options: CommissionCalculatorOptionInterface[] = [
  {
    name: 'province',
    id: 'select-AB',
    value: PROVINCES.AB,
    text: 'Alberta',
  },
  {
    name: 'province',
    id: 'select-BC',
    value: PROVINCES.BC,
    text: 'British Columbia',
  },
  {
    name: 'province',
    id: 'select-ON',
    value: PROVINCES.ON,
    text: 'Ontario',
  },
];

export default {
  StartPrice,
  MinMaxPrice,
  options,
};
